import { render, staticRenderFns } from "./LikeRoutePopups.vue?vue&type=template&id=313a30cb&scoped=true"
import script from "./LikeRoutePopups.vue?vue&type=script&lang=js"
export * from "./LikeRoutePopups.vue?vue&type=script&lang=js"
import style0 from "./LikeRoutePopups.vue?vue&type=style&index=0&id=313a30cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a30cb",
  null
  
)

export default component.exports